import { render, staticRenderFns } from "./addTravel.vue?vue&type=template&id=573efeba&scoped=true&"
import script from "./addTravel.vue?vue&type=script&lang=js&"
export * from "./addTravel.vue?vue&type=script&lang=js&"
import style0 from "./addTravel.vue?vue&type=style&index=0&id=573efeba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573efeba",
  null
  
)

export default component.exports